// Eigen geluid per soort melding (nieuwe lead, inkomsten), afgespeeld door de OS zelf als hij open staat (ook in een achtergrondtabblad).
// Zonder geluidsbestanden: de tonen worden met Web Audio gemaakt. Als de app dicht is, bepaalt het systeem het geluid.

const KEYS = { lead: "os_geluid_lead", inkomsten: "os_geluid_inkomsten" };
const STANDAARD = { lead: "klokje", inkomsten: "kassa" };
let ctx = null;

export const GELUIDEN = {
  fanfare: { naam: "Fanfare (opgaand akkoord)", noten: [[523, 0, .16], [659, .14, .16], [784, .28, .16], [1047, .42, .5]], type: "triangle" },
  kassa: { naam: "Kassa (cha-ching)", noten: [[1568, 0, .1], [2093, .1, .45], [2637, .1, .45]], type: "sine" },
  klokje: { naam: "Klokje", noten: [[880, 0, .9], [1320, .18, .8]], type: "sine" },
  dubbel: { naam: "Dubbele piep", noten: [[1000, 0, .12], [1000, .22, .12]], type: "square" },
};

export const leesKeuze = (soort = "lead") => { try { return localStorage.getItem(KEYS[soort]) || STANDAARD[soort]; } catch { return STANDAARD[soort]; } };
export const bewaarKeuze = (soort, k) => { try { localStorage.setItem(KEYS[soort], k); } catch { /* geen probleem */ } };

function context() {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
}

// Browsers staan geluid pas toe na een tik of klik. Eén keer iets aanraken in de OS volstaat.
export function ontgrendel() {
  const c = context();
  if (c && c.state === "suspended") c.resume().catch(() => {});
}

export function speel(sleutel) {
  if (sleutel === "uit") return false;
  const g = GELUIDEN[sleutel] || GELUIDEN.fanfare;
  const c = context();
  if (!c) return false;
  if (c.state === "suspended") c.resume().catch(() => {});
  const t0 = c.currentTime + 0.02;
  g.noten.forEach(([freq, start, duur]) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = g.type;
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, t0 + start);
    gain.gain.exponentialRampToValueAtTime(0.28, t0 + start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + start + duur);
    osc.connect(gain).connect(c.destination);
    osc.start(t0 + start);
    osc.stop(t0 + start + duur + 0.05);
  });
  return c.state === "running";
}
